export default "__VITE_ASSET__Bp47sj8n__"